import { COLORS } from './theme';

/**
 * The HUD's one liveness verdict, derived in App.js:
 *
 *   live    the controller (denshi) is on MQTT itself, and fresh
 *   bridge  the controller's own link is quiet, but its readings are arriving
 *           through the Pi's bridge (denshi-pi) -- the data is real and
 *           current, it just took the other road
 *   pi      only the Pi's own status is fresh: the unit is up and reachable,
 *           the firmware is not talking on either road
 *   stale   everything has gone quiet, or a device reports itself disconnected
 *   nodata  nothing has ever arrived from anything
 */
export const LINK_COLOR = {
  live: COLORS.live,
  bridge: COLORS.accent,
  pi: COLORS.alert,
  stale: COLORS.alert,
  nodata: COLORS.label,
};

export const LINK_SOURCE = {
  live: 'DENSHI',
  bridge: 'VIA PI',
  pi: 'PI ONLY',
  stale: 'LOST',
  nodata: '--',
};

export const LINK_LABEL = {
  live: 'Sensor online',
  bridge: 'Sensor data via Pi bridge',
  pi: 'Pi online · no sensor data',
  stale: 'Sensor stale',
  nodata: 'Sensor offline',
};

export const linkColor = (state) => LINK_COLOR[state] || LINK_COLOR.nodata;
